import { Component, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { resendActivationEmail } from 'src/app/root-store/jobseeker-store/jobseeker-registration/actions';
import { selectEmailVerificationResendToken, selectResendMaxAttemptsReached } from 'src/app/root-store/jobseeker-store/jobseeker-registration/selectors';
import { selectSystemConfigs } from 'src/app/root-store/selectors';
import { AppState } from 'src/app/root-store/state';

@Component({
    selector: 'app-jobseeker-registration-complete',
    templateUrl: './redesign/jobseeker-registration-complete.component.html',
    styleUrls: ['./redesign/jobseeker-registration-complete.component.scss'],
    standalone: false
})
export class JobseekerRegistrationCompleteComponent {
  private store = inject<Store<AppState>>(Store);

  maxResendAttemptsReached = this.store.selectSignal(selectResendMaxAttemptsReached);
  emailResendToken = this.store.selectSignal(selectEmailVerificationResendToken);
  systemConfigs = this.store.selectSignal(selectSystemConfigs);

  onResend() {
    this.store.dispatch(resendActivationEmail({ payload: { emailVerificationResendToken: this.emailResendToken() }}));
  }
}
